// src/app/reducers/customer.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import {
  customerIsCreatedAction,
  removeRecentCustomerAction
} from 'src/app/actions/customer/action';

export interface CustomerState {
  customers: any[];
  recentCustomer?: any;
}

export const initialState: CustomerState = {
  customers: [],
  recentCustomer: null
};

const _customerReducer = createReducer(
  initialState,
  on(customerIsCreatedAction, (state, { newCustomer }) => ({
    ...state,
    customers: [...state.customers, newCustomer],
    recentCustomer: newCustomer
  })),
  on(removeRecentCustomerAction, state => ({
    ...state,
    recentCustomer: null
  }))
);

export function customerReducer(
  state: CustomerState | undefined,
  action: Action
) {
  return _customerReducer(state, action);
}
